/* tslint:disable */
/* eslint-disable */
/**
 * Viterbit API
 * This is the documentation for viterbit\'s apps
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EmployeeFindComplaintQueryResponse2
 */
export interface EmployeeFindComplaintQueryResponse2 {
    /**
     * 
     * @type {string}
     * @memberof EmployeeFindComplaintQueryResponse2
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeFindComplaintQueryResponse2
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeFindComplaintQueryResponse2
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeFindComplaintQueryResponse2
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeFindComplaintQueryResponse2
     */
    updatedAt?: string;
    /**
     * 
     * @type {string}
     * @memberof EmployeeFindComplaintQueryResponse2
     */
    receivedAt?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EmployeeFindComplaintQueryResponse2
     */
    finishedAt?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EmployeeFindComplaintQueryResponse2
     */
    authorName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EmployeeFindComplaintQueryResponse2
     */
    authorEmail?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EmployeeFindComplaintQueryResponse2
     */
    authorPhone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EmployeeFindComplaintQueryResponse2
     */
    authorRelationship?: string | null;
}

/**
 * Check if a given object implements the EmployeeFindComplaintQueryResponse2 interface.
 */
export function instanceOfEmployeeFindComplaintQueryResponse2(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;

    return isInstance;
}

export function EmployeeFindComplaintQueryResponse2FromJSON(json: any): EmployeeFindComplaintQueryResponse2 {
    return EmployeeFindComplaintQueryResponse2FromJSONTyped(json, false);
}

export function EmployeeFindComplaintQueryResponse2FromJSONTyped(json: any, ignoreDiscriminator: boolean): EmployeeFindComplaintQueryResponse2 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'title': !exists(json, 'title') ? undefined : json['title'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'createdAt': !exists(json, 'createdAt') ? undefined : json['createdAt'],
        'updatedAt': !exists(json, 'updatedAt') ? undefined : json['updatedAt'],
        'receivedAt': !exists(json, 'receivedAt') ? undefined : json['receivedAt'],
        'finishedAt': !exists(json, 'finishedAt') ? undefined : json['finishedAt'],
        'authorName': !exists(json, 'authorName') ? undefined : json['authorName'],
        'authorEmail': !exists(json, 'authorEmail') ? undefined : json['authorEmail'],
        'authorPhone': !exists(json, 'authorPhone') ? undefined : json['authorPhone'],
        'authorRelationship': !exists(json, 'authorRelationship') ? undefined : json['authorRelationship'],
    };
}

export function EmployeeFindComplaintQueryResponse2ToJSON(value?: EmployeeFindComplaintQueryResponse2 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'title': value.title,
        'status': value.status,
        'createdAt': value.createdAt,
        'updatedAt': value.updatedAt,
        'receivedAt': value.receivedAt,
        'finishedAt': value.finishedAt,
        'authorName': value.authorName,
        'authorEmail': value.authorEmail,
        'authorPhone': value.authorPhone,
        'authorRelationship': value.authorRelationship,
    };
}

